import { ROUTES } from "../../route-paths";

/** The query parameters that make a Tenedi connections link open one connection. */
export const CARRIER_PARAM = "carrier";
export const CUSTOMER_PARAM = "customer";

/** The bench query parameter that preselects a partnership (plan section 2.7). */
export const BENCH_PARTNERSHIP_PARAM = "partnership";

/** The outbound test bench, opened on one partnership. */
export const benchLinkFor = (partnershipUuid: string): string =>
  `${ROUTES.OUTBOUND_TEST_BENCH}?${new URLSearchParams({
    [BENCH_PARTNERSHIP_PARAM]: partnershipUuid,
  }).toString()}`;

/** The Tenedi connections page, opened on one carrier and customer. */
export const tenediConnectionLinkFor = ({
  companyUuid,
  organizationUuid,
}: {
  companyUuid: string;
  organizationUuid: string;
}): string =>
  `${ROUTES.TENEDI_CONNECTIONS}?${new URLSearchParams({
    [CARRIER_PARAM]: companyUuid,
    [CUSTOMER_PARAM]: organizationUuid,
  }).toString()}`;
